import { Reducer } from 'redux';

import { IUsersState } from 'types/users.types';
import * as constants from 'redux/constants/users.constants';
import * as userConstants from 'redux/constants/user.constants';

export const defaultState: IUsersState = {
  count: 0,
  items: [],
  loading: false,
  selectedItem: null,
  table: {
    page: 1,
    limit: 10,
    search: '',
    sortKey: 'firstName',
    sortType: 'asc',
  },
};

const usersReducer: Reducer = (state = defaultState, action) => {
  const { data, type } = action;
  switch (type) {
    case constants.USERS_ON_DELETE_REQUESTED:
    case constants.USERS_ON_GET_ALL_REQUESTED:
    case constants.USERS_ON_SAVE_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case constants.USERS_ON_GET_ONE_REQUESTED:
      return {
        ...state,
        loading: !!action.id,
        selectedItem: null,
      };
    case constants.USERS_ON_GET_ALL_SUCCEEDED:
      return {
        ...state,
        count: data.count,
        items: data.items,
        loading: false,
        table: data.table,
      };
    case constants.USERS_ON_GET_ONE_SUCCEEDED:
      return {
        ...state,
        loading: false,
        selectedItem: data.item,
      };
    case constants.USERS_ON_DELETE_SUCCEEDED:
    case constants.USERS_ON_SAVE_SUCCEEDED:
    case constants.USERS_ON_DELETE_FAILED:
    case constants.USERS_ON_GET_ALL_FAILED:
    case constants.USERS_ON_SAVE_FAILED:
      return {
        ...state,
        loading: false,
      };
    case constants.USERS_ON_GET_ONE_FAILED:
      return {
        ...state,
        loading: false,
        selectedItem: null,
      };
    case userConstants.USER_ON_LOGOUT_SUCCEEDED:
      return defaultState;
    default:
      return state;
  }
};

export default usersReducer;
